import { type ReactNode } from 'react';
import { Card, cn } from '@smena/ui';

// Плитка счётчика: крупное число + подпись + необязательная сноска.
// Числа - tabular-nums, иначе в ряду плиток цифры «пляшут» по ширине.

export function StatTile({
  label,
  value,
  hint,
  tone = 'default',
}: {
  label: string;
  value: ReactNode;
  hint?: string;
  tone?: 'default' | 'warn' | 'danger';
}) {
  return (
    <Card className="p-4">
      <div className="text-xs uppercase tracking-wider text-muted">{label}</div>
      <div
        className={cn(
          'mt-1 text-2xl font-semibold tabular-nums',
          tone === 'warn' && 'text-amber',
          tone === 'danger' && 'text-destructive',
        )}
      >
        {value}
      </div>
      {hint ? <div className="mt-1 text-xs text-muted">{hint}</div> : null}
    </Card>
  );
}
